<script setup>
import { storeToRefs } from "pinia";
import { useCartStore } from "@/stores/CartStore";
import { useTrackStore } from "@/stores/TrackStore.js";
const cartStore = useCartStore();
const trackStore = useTrackStore();
const { selectedTrack } = storeToRefs(trackStore);

defineProps({
  track: {
    type: Object,
    required: true,
  },
});

const addToCart = function addToCart(track) {
  cartStore.add(track);
};

const selectArtist = function selectArtist(artistName) {
  trackStore.selectArtist(artistName);
};

const selectBpm = function selectBpm(bpm) {
  trackStore.selectBpm(bpm);
};

const selectGenre = function selectGenre(genreName) {
  trackStore.selectGenre(genreName);
};

const selectKey = function selectKey(key) {
  trackStore.selectKey(key);
};

const unselectTrack = function unselectTrack() {
  selectedTrack.value = null;
};
</script>

<template>
  <div class="col">
    <div class="card mt-5 px-3 text-white bg-dark rounded-3 shadow-sm">
      <div class="card-header py-3">
        <div class="d-flex py-1 align-items-center">
          <fa
            @click="unselectTrack"
            icon="arrow-left"
            class="fa-2x"
            style="cursor: pointer"
          />
          <div class="ms-3">
            <span
              @click="selectArtist(track.artistName)"
              role="button"
              class="text-decoration-underline text-nowrap text-uppercase"
              >{{ track.artistName }}</span
            >
            <br />{{ track.title }}
          </div>
          <div class="ms-auto">
            <fa v-if="track.vocal" icon="microphone-alt" />
            <fa v-else icon="microphone-alt-slash" />
          </div>
          <div
            class="ms-4 text-nowrap text-decoration-underline"
            @click="selectKey(track.key)"
            role="button"
          >
            {{ track.key }}
          </div>
          <div
            class="ms-4 text-nowrap text-decoration-underline"
            @click="selectBpm(track.bpm)"
            role="button"
          >
            {{ track.bpm }} BPM
          </div>
          <div class="ms-4">00:00</div>
          <div class="ms-4" @click="toggleFavorited">
            <fa v-if="favorited" icon="heart" />
            <fa v-else :icon="['far', 'heart']" />
          </div>
          <a
            @click="addToCart(track)"
            class="btn btn-primary ms-4 text-nowrap"
            href="#"
          >
            <fa icon="cart-arrow-down" />
            <span class="ms-3">Buy License</span>
          </a>
        </div>
      </div>
      <div class="card-body">
        <div class="clearfix">
          <img
            class="rounded me-4 mb-4 float-start"
            :src="track.coverArt160Url"
            width="160"
            height="160"
          />
          {{ track.description }}
        </div>
        <dl class="m-0">
          <dt>Feelings</dt>
          <dd>{{ track.feelingNames }}</dd>
          <dt>Genre</dt>
          <dd
            @click="selectGenre(track.genre?.name)"
            role="button"
            class="text-decoration-underline"
          >
            {{ track.genre?.name }}
          </dd>
          <dt>Subgenre</dt>
          <dd>{{ track.subgenre?.name }}</dd>
          <dt>Available in</dt>
          <dd>MP3 (320 Kbps), AIFF or Wave (16bit 44.1kHz / 24bit 48kHz)</dd>
        </dl>
      </div>
    </div>
  </div>
</template>

<style scoped>
dt {
  float: left;
  width: 120px;
}
dt::after {
  content: ": ";
}
dd {
  margin-left: 120px;
}
</style>
